import React from 'react'
import Fade from 'react-reveal/Fade';
import './MyWorkSection.css'

import IXLB_banner from '../../assets/IXLB_banner.webp'
import AfterEffect from '../../assets/after_effects.webp'
import Syntheyes from '../../assets/syntheyes.webp'
import Photoshop from '../../assets/photoshop.webp'
import Unreal from '../../assets/unreal.webp'
import Zbrush from '../../assets/zbrush.webp'
import Premiere from '../../assets/premiere.webp'
import Lightroom from '../../assets/lightroom.webp'



const MyWorkSection = () => {
    return (
        <>
        <div className='mywork'>
            <div className="mywork-container container">
                <div>
                <h1>Graphic Designs</h1>
                <p>This list is just a snapshot of my expertise. If you have specific software requirements not listed here, feel free to reach out. I'm always eager to expand my knowledge and take on new challenges. Let's collaborate to bring your ideas to life using the best tools for the job!</p>
                </div>
                <div className="content">
                            <Fade bottom>
                                <div className='mywork-thumbnail'>
                                <img src={IXLB_banner} alt="Maya Logo Logo" loading="lazy"/>
                                </div>
                            </Fade>


                            <Fade bottom>
                                <div className='mywork-thumbnail'>
                                <img src={AfterEffect} alt="Beacon Insurance Logo" loading="lazy"/>
                                </div>
                            </Fade>

                            <Fade bottom>
                                <div className='mywork-thumbnail'>
                                <img src={Syntheyes} alt="Bluecross Insurance Logo" loading="lazy"/>
                                </div>
                            </Fade>

                            <Fade bottom>
                                <div className='mywork-thumbnail'>
                                <img src={Photoshop} alt="Cigna Insurance Logo" loading="lazy"/>
                                </div>
                            </Fade>

                            <Fade bottom>
                                <div className='mywork-thumbnail'>
                                <img src={Unreal} alt="Horizon Insurance Logo" loading="lazy"/>
                                </div>
                            </Fade>

                            <Fade bottom>
                                <div className='mywork-thumbnail'>
                                <img src={Zbrush} alt="Optum Health Insurance Logo" loading="lazy"/>
                                </div>
                            </Fade>
                            <Fade bottom>
                                <div className='mywork-thumbnail'>
                                <img src={Premiere} alt="Optum Health Insurance Logo" loading="lazy"/>
                                </div>
                            </Fade>
                            <Fade bottom>
                                <div className='mywork-thumbnail'>
                                <img src={Lightroom} alt="Optum Health Insurance Logo" loading="lazy"/>
                                </div>
                            </Fade>
                </div>
            </div>


        </div>



        </>
    )
}

export default MyWorkSection
